var SegmentsFiltersModule = /** @class */ (function () {
    function SegmentsFiltersModule() {
    }
    return SegmentsFiltersModule;
}());
export { SegmentsFiltersModule };
